import React from 'react';
import { useWeather } from '../../context';
import { RadioGroup } from '../ui/RadioGroup';

export function ModeSelector() {
  const { currentMode, setCurrentMode, modelSelect } = useWeather();

  // Don't render for drought model
  if (modelSelect === 'drought') {
    return null;
  }

  const options = [
    { value: 'polygon', label: 'Polygon' },
    { value: 'point', label: 'Point' }
  ];

  const handleModeChange = (value: string) => {
    setCurrentMode(value);
  };

  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-[var(--secondary-text)] mb-2">
        Mode
      </label>
      <RadioGroup
        name="mode"
        value={currentMode}
        onChange={handleModeChange}
        options={options}
      />
    </div>
  );
}